import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ba31f1a")

_pushScopeId("data-v-0ba31f1a")
const _hoisted_1 = {
  key: 0,
  class: "button-group"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Nee")
const _hoisted_4 = { class: "value" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_Slider = _resolveComponent("Slider")
  const _component_Step = _resolveComponent("Step")

  return (_openBlock(), _createBlock(_component_Step, {
    step: _ctx.step,
    title: _ctx.title
  }, {
    default: _withId(() => [
      (!_ctx.currentlyWorking)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.currentlyWorking = true))
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_Button, { onClick: _ctx.nextStep }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formattedIncome) + " euro per maand ", 1),
            _createVNode(_component_Slider, {
              modelValue: _ctx.extraMonthlyIncome,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.extraMonthlyIncome = $event)),
              max: _ctx.grossMonthlySalary,
              min: 0
            }, null, 8, ["modelValue", "max"])
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _: 1
  }, 8, ["step", "title"]))
})